<template>
    <div ref="dropdownWrapper">
        <div v-if="getActions().length > 0" class="relative flex justify-center">
            <button class="focus:outline-none" @click="toggleDropdown">
                <img src="../../assets/images/vertical-dot-icon.png" alt="Up Down Arrow" class="w-[30px] h-[30px]" />
            </button>

            <ul v-if="isOpen"
                class="absolute top-[30px] right-[25px] z-10 mt-1 w-[200px] bg-white rounded-[10px] shadow-[0_0_10px_rgba(0,0,0,0.15)]
 text-[#333333] text-[15px] font-roboto py-[5px] overflow-hidden">
                <li v-for="option in getActions()" :key="option" @click="select(option)"
                    class="px-2 py-[5px] mx-[10px] my-[5px] rounded-md hover:bg-customYellow-100 hover:text-white cursor-pointer text-left">
                    {{ option }}
                </li>
            </ul>
        </div>
        <div v-else class="relative flex mr-4 justify-end">
            -
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionDropdown",

    props: ["item"],

    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    unmounted() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    methods: {

        getActions() {
            let res = ["Details"]
            if (this.item.status_slug != "cancelled") {
                res.push("Cancel")
            }
            if (this.item.can_retry) {
                res.push("Process Payment")
            }
            return res
        },

        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },

        select(option) {
            this.$emit("select", option); // parent ko notify karega
            this.isOpen = false;
        },

        handleClickOutside(e) {
            if (this.$refs.dropdownWrapper && !this.$refs.dropdownWrapper.contains(e.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>
